import type { FC } from "react";
import { useState } from "react";

import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import { PremiumFeatureCard } from "app/pages/sales-intelligence/pages/premium-features/components/PremiumFeatureCard/PremiumFeatureCard";
import { PremiumFeatureContactUsModal } from "app/pages/sales-intelligence/pages/premium-features/components/PremiumFeatureContactUsModal/PremiumFeatureContactUsModal";
import type { PremiumFeature } from "app/pages/sales-intelligence/pages/premium-features/types";
import { getPremiumFeaturesActions, getUserRole } from "app/pages/sales-intelligence/pages/premium-features/utils";
import { isNoTouch } from "app/UtilitiesAndConstants/UtilityFunctions/usersUtils";

import { StyledMostPopularContainer, StyledMostPopularContainerWrapper, StyledMostPopularHeader } from "./styles";

interface MostPopularContainerProps {
    features: readonly PremiumFeature[];
}

export const MostPopularContainer: FC<MostPopularContainerProps> = ({ features }) => {
    const [contactUsModal, setContactUsModal] = useState<boolean>(false);

    const userRole = getUserRole();
    const isNTUser = isNoTouch(swSettings);

    const handleContactUsClick = () => {
        if (!isNTUser) {
            setContactUsModal(true);
        }
    };

    return (
        <StyledMostPopularContainerWrapper>
            <StyledMostPopularHeader>
                {translate(
                    isNTUser
                        ? "si.premium-feature.block.boost-your-plan.title"
                        : "si.premium-feature.block.most-popular.title",
                )}
            </StyledMostPopularHeader>
            <StyledMostPopularContainer>
                {features.map((item: PremiumFeature) => (
                    <PremiumFeatureCard
                        key={item.type}
                        {...item}
                        {...getPremiumFeaturesActions({
                            type: item.type,
                            role: userRole,
                            onCustomClick: handleContactUsClick,
                        })}
                        size={isNTUser ? "lg" : "md"}
                    />
                ))}
            </StyledMostPopularContainer>
            <PremiumFeatureContactUsModal
                isOpen={contactUsModal}
                onClose={() => setContactUsModal(false)}
            />
        </StyledMostPopularContainerWrapper>
    );
};
